var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"padded"},[_c('files-panel',{attrs:{"title":"Site Attachments","id":_vm.rowData.id,"type":"site","read-only":_vm.readOnly}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }